import { DsLanguageMap, DsDropshippingGuideI18nTemplate } from './dsTypes';

export const dsIntegrationTemplate: DsLanguageMap<DsDropshippingGuideI18nTemplate['integration']> = {
  zh: {
    lockedTitle: '拉取平台订单',
    lockedDescription: '获得店铺授权和产品配对教程，支持亚马逊、eBay、Shopify、Temu等主流平台。完成对接后订单自动拉取，实现自动发货，无需手动录单。',
    lockedFeature1: '支持主流电商平台和ERP',
    lockedFeature2: '详细的授权和配对指引',
    lockedFeature3: '自动配对功能，快速匹配',
    lockedFeature4: '可用性测试，确保对接正确',
    actionOpenAccount: '立即开户',
    actionContact: '联系客服',
    cardStoreAuthTitle: '店铺授权',
    cardStoreAuthDescription: '店铺授权细节较多，请严格按照指引设置。',
    pullFromPlatformTitle: '从电商平台拉取（推荐）',
    pullFromPlatformDescription: '如果你希望从电商平台拉取订单，请进行平台授权，同一平台的多家店铺须进行多次授权。',
    actionPlatformAuth: '进行平台授权',
    actionViewGuide: '查看指引',
    pullFromErpTitle: '从第三方ERP拉取',
    pullFromErpDescription: '如果你希望从第三方ERP系统拉取订单，请进行ERP授权，部分ERP系统会收取授权费用。',
    actionErpAuth: '进行ERP授权',
    cardProductMappingTitle: '产品配对',
    cardProductMappingDescription: '不同店铺中的同种商品需要分别配对，否则将无法发货。',
    autoMappingTitle: '自动配对（推荐）',
    autoMappingDescription: '如果OMS和电商平台中的商品SKU一致，可以在OMS中勾选自动创建配对关系，实现自动配对。',
    actionMapNow: '立即配对',
    manualMappingTitle: '手动配对',
    manualMappingDescription: '如果OMS和电商平台中的商品SKU不一致，请进行手动配对。',
    cardTestTitle: '进行可用性测试',
    cardTestDescription: '完成店铺授权和产品配对设置后，请使用真实订单进行测试。',
    testSuccessTitle: '如果设置正确',
    testSuccessDescription: '可以在OMS中看到5天内的全部平台订单，且没有红色报错。',
    actionViewPlatformOrders: '查看平台订单',
    testFailureTitle: '如果设置错误',
    testFailureDescription: '无法看到平台订单，或数量不符、出现红色报错。',
    actionContactOms: '联系OMS客服',
  },
  en: {
    lockedTitle: 'Pull platform orders',
    lockedDescription: 'Get store authorization and product mapping guides for Amazon, eBay, Shopify, Temu, and other mainstream platforms. After setup, orders sync automatically for hands-free fulfillment.',
    lockedFeature1: 'Supports mainstream platforms and ERP systems',
    lockedFeature2: 'Detailed authorization and mapping guides',
    lockedFeature3: 'Auto-mapping for faster setup',
    lockedFeature4: 'Usability test flow to verify integration',
    actionOpenAccount: 'Open account',
    actionContact: 'Contact support',
    cardStoreAuthTitle: 'Store authorization',
    cardStoreAuthDescription: 'Store authorization has many details. Follow the guide strictly.',
    pullFromPlatformTitle: 'Pull from e-commerce platform (recommended)',
    pullFromPlatformDescription: 'If you want to pull orders directly from platforms, complete platform authorization. Multiple stores on the same platform require separate authorization.',
    actionPlatformAuth: 'Authorize platform',
    actionViewGuide: 'View guide',
    pullFromErpTitle: 'Pull from third-party ERP',
    pullFromErpDescription: 'If you want to pull orders from a third-party ERP, complete ERP authorization. Some ERP providers charge authorization fees.',
    actionErpAuth: 'Authorize ERP',
    cardProductMappingTitle: 'Product mapping',
    cardProductMappingDescription: 'The same product in different stores must be mapped separately; otherwise shipment cannot proceed.',
    autoMappingTitle: 'Auto mapping (recommended)',
    autoMappingDescription: 'If OMS SKU matches platform SKU, enable auto-create mapping relation in OMS for automatic mapping.',
    actionMapNow: 'Map now',
    manualMappingTitle: 'Manual mapping',
    manualMappingDescription: 'If OMS SKU does not match platform SKU, complete manual mapping.',
    cardTestTitle: 'Run usability test',
    cardTestDescription: 'After store authorization and product mapping, test with real orders.',
    testSuccessTitle: 'If configured correctly',
    testSuccessDescription: 'You can see all platform orders within 5 days in OMS with no red errors.',
    actionViewPlatformOrders: 'View platform orders',
    testFailureTitle: 'If configured incorrectly',
    testFailureDescription: 'Platform orders are missing, counts are incorrect, or red errors appear.',
    actionContactOms: 'Contact OMS support',
  },
};
